import styled, { css } from 'styled-components';

export const Container = styled.section`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.layout.spacing(2)};
    width: 100%;
    max-width: ${theme.layout.spacing(75)};

    input {
      border-radius: 12px;
      border: 2px dashed ${theme.palette.primary.main};
      width: 100%;
      height: 52px;
      text-align: center;
      padding: ${theme.layout.spacing(0, 2)};
      column-gap: ${theme.layout.spacing(2)};
      font-size: 1rem;
      font-weight: 600;
      background-color: transparent;
      color: ${theme.palette.text.main};
    }
  `}
`;
